/* Focal theme custom.js — My First Book customisations:
   1) homepage hero  2) Small Hands 2er shipping line  3) cart shipping/saving rows
      + free-shipping progress bar  4) PDP Kurzprofil, Einzelpreis benefits, video label
      5) Schweizer Rechtschreibung (kein ß) für den Markt Schweiz.
   Re-applies on shopify:section:* events, cart events and DOM swaps.
   NOTE: mfb-kurzprofile.js / mfb-gallery.js reuse THIS file's ?v= cache key, so bump
   the marker below whenever one of them changes.  assets-rev: 13 */
(function () {
  var STAR = 'color:#F6A429;font-weight:800;';
  var applying = false;

  function styleAward(cb) {
    var revs = [].slice.call(cb.querySelectorAll('.liquid_reviews'));
    var rateEl = revs.filter(function (el) { return el.querySelector('img'); })[0];
    var awardEls = revs.filter(function (el) { return /Deutscher Spielzeugpreis Gewinner/.test(el.textContent); });
    if (awardEls.length === 0) {
      var d = document.createElement('div');
      d.className = 'liquid_reviews mfb-award-line';
      d.style.marginTop = '2px';
      d.innerHTML = '<span style="' + STAR + '">Deutscher Spielzeugpreis Gewinner</span>';
      if (rateEl) rateEl.after(d); else cb.prepend(d);
    } else {
      awardEls.forEach(function (el, i) {
        if (i > 0) { el.remove(); return; }
        var sp = el.querySelector('span');
        if (sp) sp.setAttribute('style', STAR);
      });
    }
    return rateEl;
  }

  function apply() {
    if (applying) return false;
    var s = document.querySelector('.hp_banner .slideshow__slide');
    if (!s) return false;
    var cb = s.querySelector('.content-box');
    var logos = s.querySelector('.logos_content');
    var rte = cb && cb.querySelector('.rte_text');
    var btn = cb && cb.querySelector('.button-wrapper');
    if (!cb || !logos || !rte || !btn) return false;

    applying = true;

    if (!btn.dataset.mfbH) {
      btn.dataset.mfbH = '1';
      logos._h = { p: logos.parentNode, n: logos.nextSibling };
      btn._h = { p: btn.parentNode, n: btn.nextSibling };
    }

    styleAward(cb); // award colour on both breakpoints

    if (window.matchMedia('(max-width:767px)').matches) {
      s.style.position = 'relative';
      var stack = s.querySelector('.mfb-bottom-stack');
      if (!stack) { stack = document.createElement('div'); stack.className = 'mfb-bottom-stack'; s.appendChild(stack); }
      stack.style.cssText = 'position:absolute;left:16px;right:16px;bottom:18px;margin:0;z-index:5;display:flex;flex-direction:column;align-items:center;gap:14px;';
      logos.style.cssText = 'background:transparent;margin:0;';
      if (stack.firstChild !== logos) stack.appendChild(logos);
      stack.appendChild(btn);
      btn.style.cssText = 'margin:0;';
    } else {
      // Desktop: restore original order (award colour stays via styleAward).
      var stack = s.querySelector('.mfb-bottom-stack');
      btn.style.cssText = '';
      logos.style.cssText = '';
      if (logos._h) logos._h.p.insertBefore(logos, logos._h.n);
      if (btn._h) btn._h.p.insertBefore(btn, btn._h.n);
      if (stack) stack.remove();
    }
    applying = false;
    return true;
  }

  function boot() { if (!apply()) setTimeout(boot, 300); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('load', function (e) {
    if (e.target && e.target.tagName === 'IMG' && e.target.closest && e.target.closest('.hp_banner')) apply();
  }, true);

  ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(apply, 60); });
  });

  // Banner subtree swapped? The un-tagged button tells us it's a fresh render.
  var banner = document.querySelector('.hp_banner');
  if (banner && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      var b = document.querySelector('.hp_banner .slideshow__slide .button-wrapper');
      if (b && !b.dataset.mfbH) apply();
    });
    mo.observe(banner, { childList: true, subtree: true });
  }

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(apply, 200);
  });
})();

/* MFB: "+ kostenloser Versand" under the Small Hands 2er-Set (theme has only a 3er). */
(function () {
  function add() {
    var t2 = document.getElementById('bundle_tier_2');
    var t3 = document.getElementById('bundle_tier_3');
    if (!t2 || !t3 || t2.parentNode !== t3.parentNode) return false;
    if (t3.parentNode.querySelector('.mfb-2er-ship')) return true;
    var d = document.createElement('div');
    d.className = 'free_shipping mfb-2er-ship';
    d.innerHTML = '<img src="//myfirstbookmall.de/cdn/shop/files/delivery-truck-01_1.svg?v=1780999841" alt="" width="" height=""><span>+ kostenloser Versand</span>';
    t3.parentNode.insertBefore(d, t3);
    return true;
  }
  var tries = 0;
  function boot() { if (add()) return; if (++tries < 25) setTimeout(boot, 300); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  var stack = document.querySelector('.product_bundle_lbrgt_main');
  if (stack && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (!document.querySelector('.mfb-2er-ship')) add();
    });
    mo.observe(stack, { childList: true });
  }
})();

/* MFB cart: shipping saving ("Versand" struck rate -> 0,00) + product saving
   ("Du sparst"). Rates/thresholds mirror the Shopify delivery profile.
   Expensive zones (GB, CY, MC, Middle East) never get free shipping. */
(function () {
  var SAVE_RED = '#EB001B';    // the theme's sale red (struck-through prices)
  var LABEL_BLACK = '#111111'; // label colour, matches the theme's price black
  var ZONES = [
    { c: ['DE'], rate: 390, free: 5000 },
    { c: ['FR'], rate: 490, free: 5000 },
    { c: ['IT'], rate: 490, free: 5000 },
    { c: ['CH'], rate: 490, free: 5000 },
    { c: ['AT', 'BE', 'LU', 'NL', 'PL', 'LI'], rate: 490, free: 4999 },
    { c: ['PT', 'ES'], rate: 699, free: 5000 },
    { c: ['DK', 'FI', 'NO', 'SE', 'FO', 'IS'], rate: 599, free: 5000 },
    { c: ['GB'], rate: 690, free: null },
    { c: ['CY'], rate: 690, free: null },
    { c: ['MC'], rate: 699, free: null },
    { c: ['AE', 'JO', 'LB', 'OM', 'QA', 'SA', 'YE'], rate: 1290, free: null }
  ];
  var FREE_QTY = 2, MAX_SHIP_DISC = 600; // discount "Gratisversand ab 2 Artikeln", max 6,00 EUR

  function zone() {
    var cc = (window.Shopify && Shopify.country) || 'DE';
    for (var i = 0; i < ZONES.length; i++) if (ZONES[i].c.indexOf(cc) > -1) return ZONES[i];
    return null;
  }

  // Uses the shop's configured money format (Admin > Settings > General)
  // instead of a hardcoded one, so these rows match the rest of the shop
  // and follow the market's currency (CHF/GBP) automatically.
  function money(cents) {
    var fmt = (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat)
              || '{{ amount_with_comma_separator }} €';
    var v = cents / 100;
    function split(dec, thousands) {
      var p = v.toFixed(2).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + dec + p[1];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount_with_comma_separator':      return split(',', '.');
        case 'amount_with_apostrophe_separator': return split('.', "'");
        case 'amount_no_decimals':               return String(Math.round(v));
        case 'amount_no_decimals_with_comma_separator':
          return String(Math.round(v)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default:                                 return split('.', ',');  // amount
      }
    });
  }

  var pcache = {};
  function product(handle) {
    if (pcache[handle]) return pcache[handle];
    pcache[handle] = fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .catch(function () { return { variants: [] }; });
    return pcache[handle];
  }

  function row(label, valueHtml, cls) {
    var d = document.createElement('div');
    d.className = 'min_cart_footer_total_flex mfb-cart-extra ' + cls;
    d.innerHTML = '<span class="total_label">' + label + '</span>' +
                  '<span class="total_amount">' + valueHtml + '</span>';
    return d;
  }

  function pageRow(label, valueHtml, cls) {
    var d = document.createElement('div');
    d.className = 'mfb-cart-extra ' + cls;
    d.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px;font-size:14px;';
    d.innerHTML = '<span>' + label + '</span><span>' + valueHtml + '</span>';
    return d;
  }

  // Hide the theme's own "Ersparnisse" row — ours covers products AND shipping.
  function hideNativeSaving(scope) {
    [].slice.call(scope.querySelectorAll('*')).forEach(function (e) {
      if (e.children.length === 0 && /^\s*Ersparnisse?\s*$/i.test(e.textContent) &&
          !(e.closest && e.closest('.mfb-cart-extra'))) {
        var r = (e.closest && e.closest('.min_cart_footer_total_flex')) || e.parentNode;
        if (r) r.style.display = 'none';
      }
    });
  }

  // Savings use the theme's sale red (as struck prices), not the default green.
  function recolorSavings() {
    [].slice.call(document.querySelectorAll(
      '.min_cart_footer_total .discount_p, .cart__recap-block .discount_p, .line-item__savings'
    )).forEach(function (e) { e.style.setProperty('color', SAVE_RED, 'important'); });
  }

  // The theme's progress bar only knows the value threshold — correct it for the qty rule.
  function shipBar(cart, z) {
    var t = document.querySelector('.new_free_shipping_text');
    if (!t || !z || z.rate > MAX_SHIP_DISC) return;
    if (z.free !== null && cart.total_price >= z.free) return; // theme message already correct
    var left = FREE_QTY - cart.item_count;
    t.textContent = left > 0
      ? 'Nur noch ' + left + ' Artikel bis zum kostenlosen Versand'
      : 'Kostenloser Versand freigeschaltet 🎉';
    var b = document.querySelector('.new_free_shipping_bar_1');
    if (!b) return;
    var p = Math.max(cart.item_count / FREE_QTY, z.free ? cart.total_price / z.free : 0);
    p = Math.min(100, Math.round(p * 100));
    b.style.setProperty('--fill', p + '%');
    if (p >= 100) b.classList.add('full');
  }

  function paint(shipHtml, saveHtml) {
    [].slice.call(document.querySelectorAll('.mfb-cart-extra')).forEach(function (e) { e.remove(); });

    // Drawer: right below "Zwischensumme".
    var box = document.querySelector('.min_cart_footer_total');
    if (box) {
      hideNativeSaving(box);
      var first = box.querySelector('.min_cart_footer_total_flex');
      var after = first ? first.nextSibling : box.firstChild;
      if (shipHtml) box.insertBefore(row('Versand', shipHtml, 'mfb-ship-row'), after);
      if (saveHtml) box.insertBefore(row('Du sparst', saveHtml, 'mfb-save-row'), after);
    }

    // Cart page: insert above the "Gesamt" block.
    var rec = document.querySelector('.cart__recap-block');
    var tot = rec && rec.querySelector('.cart__total-container');
    if (tot) {
      hideNativeSaving(rec);
      if (shipHtml) rec.insertBefore(pageRow('Versand', shipHtml, 'mfb-ship-row'), tot);
      if (saveHtml) rec.insertBefore(pageRow('Du sparst', saveHtml, 'mfb-save-row'), tot);
    }

    recolorSavings();
  }

  function update() {
    if (!document.querySelector('.min_cart_footer_total, .cart__recap-block')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) { paint(null, null); return; }

        var z = zone();
        var shipHtml = null, shipSaved = 0;
        // free via the qty discount (only where the rate is <= its 6,00 EUR cap) or the value threshold
        if (z && ((cart.item_count >= FREE_QTY && z.rate <= MAX_SHIP_DISC) || (z.free !== null && cart.total_price >= z.free))) {
          shipHtml = '<s style="opacity:.55;font-weight:400;">' + money(z.rate) + '</s> ' + money(0);
          shipSaved = z.rate;
        }
        shipBar(cart, z);

        var handles = {};
        cart.items.forEach(function (i) { handles[i.handle] = 1; });
        Promise.all(Object.keys(handles).map(product)).then(function (list) {
          var by = {};
          Object.keys(handles).forEach(function (h, n) { by[h] = list[n]; });
          var saved = shipSaved; // products + shipping
          cart.items.forEach(function (i) {
            var p = by[i.handle];
            if (!p || !p.variants) return;
            var v = p.variants.filter(function (x) { return x.id === i.variant_id; })[0];
            if (v && v.compare_at_price && v.compare_at_price > v.price) {
              saved += (v.compare_at_price - v.price) * i.quantity;
            }
            saved += i.line_level_total_discount || 0; // cart discounts, e.g. "Small Hands 1+1"
          });
          paint(shipHtml, saved > 0 ? '<span style="color:' + SAVE_RED + ';font-weight:600;">' + money(saved) + '</span>' : null);
        });
      })
      .catch(function () {});
  }

  var t;
  function schedule() { clearTimeout(t); t = setTimeout(update, 250); }

  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);

  document.documentElement.addEventListener('cart:refresh', schedule);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('shopify:section:load', schedule);

  // The drawer markup is replaced wholesale on cart changes — re-inject when it reappears.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (document.querySelector('.min_cart_footer_total') && !document.querySelector('.mfb-cart-extra')) schedule();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* MFB PDP: Kurzprofil under the title + the 4 checkmark benefits moved into the
   "Einzelpreis" box. Texts live in assets/mfb-kurzprofile.js. */
(function () {
  function loadData(cb) {
    if (window.MFB_KP) { cb(); return; }
    var cur = document.querySelector('script[src*="custom.js"]');
    if (!cur) { cb(); return; }
    var s = document.createElement('script');
    // Keep custom.js's ?v= cache key — an un-versioned asset URL can be served
    // stale by the Shopify CDN.
    s.src = cur.src.replace('custom.js', 'mfb-kurzprofile.js');
    s.onload = cb;
    s.onerror = cb;
    document.head.appendChild(s);
    var g = document.createElement('script'); // gallery info panel
    g.src = cur.src.replace('custom.js', 'mfb-gallery.js');
    document.head.appendChild(g);
  }

  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function benefitsToEinzelpreis(fb) {
    var box = document.querySelector('.product_bundle_13_36[data-slot-13-36-active="1"]')
           || document.getElementById('bundle_tier_1');
    if (!box || box.querySelector('.mfb-einzel-benefits')) return;
    var items = [].slice.call(fb.querySelectorAll('.feature-item')).map(function (el) {
      return el.textContent.replace(/\s+/g, ' ').trim();
    }).filter(Boolean);
    if (!items.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'bundles_13_36_card_main_box mfb-einzel-benefits';
    wrap.style.borderTop = '1px solid #ededed';
    var lc = document.createElement('div');
    lc.className = 'bundles_13_36_card_list_content';
    var ul = document.createElement('ul');
    ul.style.borderBottom = 'none';
    items.forEach(function (t) {
      var li = document.createElement('li');
      li.textContent = t;
      ul.appendChild(li);
    });
    lc.appendChild(ul);
    wrap.appendChild(lc);
    box.appendChild(wrap);
  }

  function apply() {
    var kp = window.MFB_KP;
    if (!kp) return true;
    var h = handle();
    var key = h && kp.M[h];
    if (!key || !kp.T[key]) return true;   // page without a Kurzprofil -> nothing to do
    var fb = document.querySelector('.product-form .feature-box, .product__info .feature-box, .feature-box');
    if (!fb) return false;                 // not rendered yet -> retry
    if (!document.querySelector('.mfb-kurzprofil')) {
      var d = document.createElement('div');
      d.className = 'mfb-kurzprofil';
      d.style.cssText = 'margin:14px 0 6px;font-size:16px;line-height:1.6;color:#3d3a34;';
      d.innerHTML = kp.T[key];
      fb.parentNode.insertBefore(d, fb);
    }
    benefitsToEinzelpreis(fb);             // read texts first, then hide the original
    fb.style.display = 'none';
    return true;
  }

  // PDP video button label: "So funktionierts" -> "Im Video ansehen" (German only;
  // the theme hardcodes per-locale labels in snippets/product-media.liquid).
  function videoLabel() {
    [].slice.call(document.querySelectorAll('.pdp_video_gallery span')).forEach(function (sp) {
      if (/^\s*So funktioniert'?s\s*$/.test(sp.textContent)) sp.textContent = 'Im Video ansehen';
    });
  }

  var tries = 0;
  function boot() { videoLabel(); if (apply()) return; if (++tries < 30) setTimeout(boot, 300); }
  // The media block can be re-rendered on variant change, so re-apply the label.
  setTimeout(videoLabel, 500);
  setTimeout(videoLabel, 1500);

  loadData(function () {
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    ['shopify:section:load', 'shopify:section:select'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(function () { videoLabel(); apply(); }, 60); });
    });
  });
})();

/* MFB Schweiz: Schweizer Rechtschreibung — kein ß, durchgaengig ss.

   Im Schweizer Hochdeutsch gibt es kein ß. Statt rund 400 Einzelfelder
   (Galerietexte, Produktuntertitel, 120 Metaobjekte, Theme-Texte, Seiten)
   je Markt zu pflegen — und bei jedem neuen Produkt nachzuziehen — setzt
   diese Regel die Ersetzung zur Laufzeit um. Sie greift damit automatisch
   auch fuer alle kuenftigen Texte.

   ß -> ss ist im Schweizer Hochdeutsch ausnahmslos richtig, deshalb ist die
   Ersetzung verlustfrei und braucht keine Wortliste.

   NICHT betroffen: Preise, Waehrungen und Rechtstexte. Die sind als
   markt-spezifische Uebersetzungen hinterlegt (Admin > Uebersetzungen),
   weil dort nicht die Schreibweise, sondern der Inhalt abweicht. */
(function () {
  if (!window.Shopify || Shopify.country !== 'CH') return;

  var UEBERSPRINGEN = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, CODE: 1, PRE: 1 };

  function textKnoten(wurzel) {
    if (!wurzel) return;
    var w = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('ß') === -1) return NodeFilter.FILTER_REJECT;
        if (n.parentNode && UEBERSPRINGEN[n.parentNode.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var treffer = [], n;
    while ((n = w.nextNode())) treffer.push(n);
    treffer.forEach(function (t) { t.nodeValue = t.nodeValue.split('ß').join('ss'); });
  }

  function lauf() {
    textKnoten(document.body);

    // Attribute, die der Kunde ebenfalls zu sehen bekommt
    ['placeholder', 'title', 'alt', 'aria-label'].forEach(function (attr) {
      var liste = document.querySelectorAll('[' + attr + '*="ß"]');
      [].slice.call(liste).forEach(function (e) {
        e.setAttribute(attr, e.getAttribute(attr).split('ß').join('ss'));
      });
    });

    if (document.title.indexOf('ß') > -1) {
      document.title = document.title.split('ß').join('ss');
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lauf);
  else lauf();

  // Nachgeladene Inhalte mitnehmen: Warenkorb-Drawer, Galerie-Overlay, Popups,
  // Bewertungen. Gedrosselt, und da die Ersetzung idempotent ist, kann sie
  // sich nicht selbst aufschaukeln.
  if (window.MutationObserver) {
    var geplant = false;
    var mo = new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      setTimeout(function () { geplant = false; lauf(); }, 200);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('shopify:section:load', lauf);
})();
